import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export async function uploadFile(file, folder) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/admin/upload?folder=${folder}`, fd);
  return data.url;
}

export const UrlUpload = ({ label, value, onChange, folder, testid, accept = "image/*" }) => {
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      onChange(await uploadFile(f, folder));
      toast.success("Uploaded to Cloudinary");
    } catch (err) {
      toast.error(errMsg(err, "Upload failed"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div>
      <span className="field-label mb-1">{label}</span>
      <div className="flex gap-2">
        <input className="admin-input" value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="https://res.cloudinary.com/…" data-testid={`${testid}-url`} />
        <label className="cursor-pointer whitespace-nowrap border border-[#1A1A1A] px-3 py-2 text-xs">
          {busy ? "…" : "Upload"}
          <input type="file" accept={accept} className="hidden" onChange={pick} data-testid={`${testid}-file`} />
        </label>
      </div>
    </div>
  );
};
